<template>
  <section class="block container is-fluid">
    <br />
    <b-steps v-model="currentStepItem">
      <b-step-item step="1" label="Panier">
        <div class="panier">
          <h1 class="title has-text-centered">Votre panier :</h1>
          <div class="columns is-multiline">
            <DetailPanier
              class="column is-8 is-offset-2"
              :panier="panier"
              :isFreeze="false"
            />
          </div>
        </div>
      </b-step-item>

      <b-step-item step="2" label="Livraison">
        <h1 class="title has-text-centered">Livraison</h1>
        <Livraison
          :livraisonSelect="livraisonSelect"
          @update:livraisonSelect="updateLivraisonSelect"
          :panierIsConfirm="panierIsConfirm"
          @update:panierIsConfirm="updatePanierIsConfirm"
          :pointRelais="pointRelais"
          v-show="panierIsConfirm"
        />
      </b-step-item>

      <b-step-item step="3" label="Finaliser la commande" disabled>
        <h1 class="title has-text-centered">Finaliser la commande</h1>
        <br />
        <div class="columns is-multiline">
          <div class="column is-7 is-neon-persist is-mb">
            <h2 class="title">Votre Panier :</h2>
            <DetailPanier :panier="panier" :isFreeze="true" />
          </div>

          <div class="column is-4 is-offset-1 is-neon-persist is-mb">
            <h2 class="title">Votre lieu de livraison :</h2>
            <div class="box" v-show="pointRelais.id">
              <article class="media">
                <div class="media-left">
                  <b-icon icon="store-alt" size="is-large"></b-icon>
                </div>
                <div class="media-content">
                  <div class="content">
                    <p>
                      <strong>{{ pointRelais.nom }}</strong>
                      <br />
                      {{ pointRelais.adresse1 }}
                      <br />
                      {{ pointRelais.cp + " - " + pointRelais.ville }}
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
        <br />
        <div class="buttons is-centered">
          <b-button type="is-success" @click="canPay = true"
            >Valider et payer</b-button
          >
        </div>
        <div class="columns is-centered">
          <div v-show="canPay" class="column is-3">
            <PayPal
              :panier="panier"
              :canPay="canPay"
              @update:canPay="updateCanPay"
              :pointRelais="pointRelais"
            />
          </div>
        </div>
      </b-step-item>

      <template slot="navigation" slot-scope="{ previous, next }">
        <div class="buttons is-centered">
          <b-button
            outlined
            type="is-danger"
            icon-pack="fas"
            icon-left="backward"
            :disabled="previous.disabled"
            v-show="!previous.disabled"
            @click.prevent="previous.action"
          >
            Retour
          </b-button>
          <b-button
            outlined
            type="is-success"
            icon-pack="fas"
            icon-right="forward"
            :disabled="
              next.disabled || (currentStepItem === 1 && !livraisonSelect)
            "
            v-show="!next.disabled && panier.liste.length"
            @click.prevent="next.action"
          >
            Suivant
          </b-button>
        </div>
      </template>
    </b-steps>
  </section>
</template>

<script>
import Panier from "../classes/Panier.js";
import DetailPanier from "@/components/DetailPanier.vue";
import Livraison from "@/components/Livraison.vue";
import PayPal from "@/components/PayPal.vue";
export default {
  name: "Panier",
  components: {
    DetailPanier,
    PayPal,
    Livraison,
  },
  data() {
    return {
      livraisonSelect: false,
      canPay: false,
      panierIsConfirm: true,
      panier: new Panier(this.$store.state.panier),
      currentStepItem: 0,
      pointRelais: {
        id: null,
        nom: null,
        adresse1: null,
        adresse2: null,
        cp: null,
        ville: null,
        pays: null,
      },
    };
  },
  methods: {
    updateCanPay(canPay) {
      this.canPay = canPay;
    },
    updatePanierIsConfirm(panierIsConfirm) {
      this.panierIsConfirm = panierIsConfirm;
    },
    updateLivraisonSelect(livraisonSelect) {
      this.livraisonSelect = livraisonSelect;
    },
  },
};
</script>